const tabs = {
    'simple-tab': {
        navTabItem: {
            flexGrow: 'initial',
        },
        tabContent: {
            boxShadow: 'none',
            borderRadius: '0px',
            minXsScreen: {
                padding: '24px',
            },
            minMdScreen: {
                padding: '24px',
            },
        },
    },
    'full-width': {
        navTabItem: {
            flexGrow: '1',
        },
        tabContent: {
            boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.12)',
            borderRadius: '0px 0px 8px 8px',
            minXsScreen: {
                padding: '18px 16px 16px',
            },
            minMdScreen: {
                padding: '32px 24px 24px',
            },
        },
    },
};
export default tabs;
